{
  "table": {
    "id": "ID",
    "name": "Name",
    "type": "Type",
    "nextDate": "Next date",
    "noOfAttachedProducts": "# of attached products",
    "action": "Action",
    "noOfSchedules": "# of schedules"
  },
  "modelName": "Trading Schedule",
  "action": "Edit",
  "addModal": {
    "title": "Add new schedule",
    "name": "Name",
    "scheduleDate": "Schedule date",
    "addDate": "Add new date",
    "update": "Update",
    "type": "Type",
    "manual": "Manual",
    "auto": "Automatic",
    "create": "Create",
    "updateTitle": "Update schedule",
    "duplicateError": "Can not have duplicate schedule dates!"
  }
}
